// NATIVE 
import React, { useEffect, useState } from 'react';

// INSTALLED 
import { useDispatch } from 'react-redux';
import Divider from '@mui/material/Divider';
import { Box, Button, Card, Grid, IconButton, Tooltip } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

// CUSTOM 
import { IconByString } from '../../IconByString';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';
import { uploadPdfStore } from '../../../store/uploaders';
import { useField, useFormikContext } from 'formik';



export const Archivos = (props:any) => {


    const dispatch = useDispatch();

    const [percentage_upload_rut, setPercentageUploadRut] = useState(0);
    // const [file_rut, setFileRut] = useState(null);
    const [file_rut_name, setRutFileName] = useState('');

    const [percentage_upload_cc, setPercentageUploadCc]   = useState(0);
    const [file_cc, setFileCc]   = useState(null);
    const [file_cc_name, setCcFileName] = useState('');

    const [percentage_upload_cb, setPercentageUploadCb]   = useState(0);
    const [file_cb, setFileCb]   = useState(null);
    const [file_cb_name, setCbFileName] = useState('');


    const { formField: {
      rut,
      chamber_of_commerce,
      bank_certificate,
    }
  } = props;


  

  const [field, meta] = useField(props);
  const formikProps:any = useFormikContext();


  useEffect(() => {
    
    if (formikProps.values.rut) {
        setPercentageUploadRut(100);
    }
    if (formikProps.values.chamber_of_commerce) {
      setPercentageUploadCc(100);
    }
    if (formikProps.values.bank_certificate) {
      setPercentageUploadCb(100);
    }
    
  }, [])
  
    

  const uploadRut = async({ target }:any) => {
    
    formikProps.setFieldValue('rut', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'pdf-company', target.files[0], setPercentageUploadRut) );
    
    if (ok) {
      formikProps.setFieldValue('rut_name_saved_file', data.pdfName);
    }
    
  }




  const uploadCc = async({ target }:any) => {
   
    formikProps.setFieldValue('chamber_of_commerce', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'pdf-company', target.files[0], setPercentageUploadCc) );
    
    if (ok) {
      formikProps.setFieldValue('chamber_of_commerce_name_saved_name', data.pdfName);
    }
  }


  const uploadCb = async({ target }:any) => {
   
    formikProps.setFieldValue('bank_certificate', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'pdf-company' ,target.files[0], setPercentageUploadCb) );
    
    if (ok) {
       formikProps.setFieldValue('bank_certificate_name_saved_name', data.pdfName);
    }

  }
  
  return (
    <div>
        <Grid container spacing={2}>
            <Grid item xs={4}>
                <Button>  RUT  </Button>
                <Tooltip title="El RUT o Registro Único Tributario permite identificar, ubicar y clasificar a las personas y entidades, en su caso, que sean contribuyentes declarantes del impuesto de la renta y no contribuyentes declarantes de ingresos y patrimonio." >
                  <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                </Tooltip>
                <Divider/>
                
                <UploadButtonField accept={'application/pdf'} 
                                   name={rut.name} label={rut.label} 
                                   text={'Rut'} 
                                   onChange={uploadRut} />
                {
                  formikProps.values.rut 
                       ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                         <LinearProgressWithLabel percentage={percentage_upload_rut} label={formikProps.values.rut.name} hasIcon={true} /> 
                        </Card>
                       :
                       ''
                }
                
            </Grid>  
            <Grid item xs={4}>
                <Button>  CÁMARA Y COMERCIO   </Button>
                <Tooltip title="Es toda actividad económica organizada para la producción, transformación, circulación, administración o custodia de bienes, o para la prestación de servicios. La empresa puede ejecutar actividades de naturaleza industrial o productiva; comercial o de prestación de servicios." >
                  <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                </Tooltip>
                <Divider/>
                <UploadButtonField accept={'application/pdf'} 
                                   name={chamber_of_commerce.name} 
                                   label={chamber_of_commerce.label} 
                                   text={'Cámara y Comercio'} 
                                   onChange={uploadCc}/>
                
                {
                  formikProps.values.chamber_of_commerce
                       ?
                       <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                        <LinearProgressWithLabel percentage={percentage_upload_cc} label={formikProps.values.chamber_of_commerce.name} hasIcon={true} />
                       </Card>
                       :
                       ''
                }
            </Grid>
            <Grid item xs={4}>
                <Button>  CERTIFICADO BANCARIO   </Button>
                <Tooltip title="El Certificado Bancario es un título valor en moneda nacional o extranjera que es emitido al portador o nominativo por las empresas bancarias, en respaldo de la entrega de dinero en moneda extranjera, que garantiza una adecuada rentabilidad e inmediata liquidez." >
                  <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                </Tooltip>
                <Divider/>
                <UploadButtonField accept={'application/pdf'} 
                                   name={bank_certificate.name} 
                                   label={bank_certificate.label} 
                                   text={'Certificado bancario'} 
                                   onChange={uploadCb}/>
                
                {
                  formikProps.values.bank_certificate
                       ?
                       <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                          <LinearProgressWithLabel percentage={percentage_upload_cb} label={formikProps.values.bank_certificate.name} hasIcon={true}/>
                        </Card>
                       :
                       ''
                }
            </Grid>
        </Grid>
    </div> 
  )
}
